export default __webpack_public_path__ + "static/media/marketplace-trending.d29bcd9f.png";